import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Home from '@/pages/Home'
import homeIndex from '@/pages/Home/homeIndex'
import agentManagement from '@/pages/Home/agentManagement'
import projectManagement from '@/pages/Home/projectManagement'
import userManagement from '@/pages/Home/userManagement'
import equipmentLibrary from '@/pages/Home/equipmentLibrary/device_library'
// import equipmentLibrary from '@/pages/Home/equipmentLibrary'
import softwareUpgrade from '@/pages/Home/softwareUpgrade'
// import addEquipment from '@/pages/Home/addEquipment'
import equipmentModel from '@/pages/Home/equipmentModel'
import modelManagement from '@/pages/Home/modelManagement'
import firmwareUpdate from '@/pages/Home/firmwareUpdate'

Vue.use(Router)

// 获取原型对象的push函数
const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Home',
      name: '首页',
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      component: Home,
      // redirect: "/homeIndex",
      children:[
        {
          path: "homeIndex",
          name: "云管理",
          component: homeIndex
        },
        {
          path: "agentManagement",
          name: "代理商管理",
          component: agentManagement
        },
        {
          path: "projectManagement",
          name: "项目管理",
          component: projectManagement
        },
        {
          path: "userManagement",
          name: "用户管理",
          component: userManagement
        },
        {
          path: "equipmentLibrary",
          name: "设备库",
          component: equipmentLibrary
        },
        {
          path: "softwareUpgrade",
          name: "软件升级",
          component: softwareUpgrade
        },
        // {
        //   path: "addEquipment",
        //   name: "模型管理",
        //   component: addEquipment
        // },
        {
          path: "equipmentModel",
          name: "模型设备",
          component: equipmentModel
        },
        {
          path: "modelManagement",
          name: "模型管理",
          component: modelManagement
        },
        {
          path: "firmwareUpdate",
          name: "固件管理",
          component: firmwareUpdate
        },
        {
          path: "device-manage",
          name: "DeviceManage",
          component: () => import('@/pages/Home/new-device-library/device-manage')
        },
        {
          path: "module-manage",
          name: "ModuleManage",
          component: () => import('@/pages/Home/new-device-library/module-manage')
        },
        {
          path: "sys-manage",
          name: "SysManage",
          component: () => import('@/pages/Home/new-device-library/sys-manage')
        },
        {
          path: "module-sys",
          name: "ModuleSys",
          component: () => import('@/pages/Home/new-device-library/module-bind-sys')
        },
        {
          path: "device-category",
          name: "deviceCategory",
          component: () => import('@/pages/Home/new-device-library/device-category')
        },
        {
          path: "deviceRepositoryLanguage",
          name: "设备库语言",
          component: () => import('@/pages/Home/deviceRepositoryLanguage')
        },
        {
          path: "packageManagement",
          name: "套餐管理",
          component: () => import('@/pages/Home/packageManagement')
        },
        {
          path: "infraredCodeLibrary",
          name: "红外码库",
          component: () => import('@/pages/Home/infraredCodeLibrary')
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js